export default __webpack_public_path__ + "static/media/logo_full.33058405.svg";